/**
 * CSK Demo Hub - per-demo scope wrapper.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React, { Suspense, type ComponentType } from "react";
import { HubDemoFrame, HubRouteLoading } from "@csk/demo-ui";

export interface DemoFrameProps {
  readonly slug: string;
  readonly title: string;
  readonly component: ComponentType;
}

export function DemoFrame({
  slug,
  title,
  component: Demo,
}: DemoFrameProps): React.JSX.Element {
  return (
    <HubDemoFrame slug={slug} title={title}>
      <Suspense fallback={<HubRouteLoading title={title} />}>
        <Demo />
      </Suspense>
    </HubDemoFrame>
  );
}
